import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

const Portfolio = () => {

  const location = useLocation();

  const data = {
    Mobile: [
      {
        title: "E-Trend App",
        images: [
          "/images/1-Etrend/2374-1.jpg",
          "/images/1-Etrend/2374-2.jpg",
          "/images/1-Etrend/2374-3.jpg",
        ],
        link: "https://play.google.com/store/apps/details?id=com.lifetimecreation.embroideryPhotoImageDesignTrend2022_23&hl=en_IN",
      },
      {
        title: "EmbroideryBusiness App",
        images: [
          "/images/2-EmbroideryBusiness/1.jpg",
          "/images/2-EmbroideryBusiness/2.jpg",
          "/images/2-EmbroideryBusiness/3.jpg",
           "/images/2-EmbroideryBusiness/4.jpg",
            "/images/2-EmbroideryBusiness/5.jpg",
             "/images/2-EmbroideryBusiness/6.jpg",
              "/images/2-EmbroideryBusiness/7.jpg",
        ],
        link: "https://play.google.com/store/apps/details?id=com.lifetimeinfotech.embroideryMachineBusiness&hl=en_IN",
      },
      {
        title: "EmbroideryDesignWorkGallery App",
        images: [ "/images/3-EmbroideryDesignWorkGallery/1.jpg",
          "/images/3-EmbroideryDesignWorkGallery/2.jpg",
        ],
        link: "https://play.google.com/store/apps/details?id=lifetimeinfotech.embroiderydesign.work_gallery&hl=en_IN",
      },
      {
        title: "EmbroideryDesignStudio",
        images: ["/images/4-EmbroideryDesignStudio/1.jpg",
          "/images/4-EmbroideryDesignStudio/1.jpg",
        ],
        
        link: "https://play.google.com/store/apps/details?id=embroidery.design.studio&hl=en_IN",
      },
      {
        title: "All Hindu God Wallpaper",
        images: ["/images/5-All Hindu God Wallpaper/1.jpg",
          "/images/5-All Hindu God Wallpaper/2.jpg",
          "/images/5-All Hindu God Wallpaper/3.jpg",
          "/images/5-All Hindu God Wallpaper/4.jpg",
        ],
        link: "https://play.google.com/store/apps/details?id=lifetimeinfotech.all_hindu_gods.hd_wallpapers&hl=en_IN",
      },
    ],

    Web: [
      {
        title: "LifetimeCreation",
        images: ["/images/web/lifetime/1.png",
          "/images/web/lifetime/2.png",
          "/images/web/lifetime/3.png"
        ],
        link: "https://www.lifetimecreation.in/",
      },
      // {
      //   title: "E-Commerce Platform",
      //   images: ["/images/web3.jpg"],
      //   link: "#",
      // },
      // {
      //   title: "Landing Page",
      //   images: ["/images/web1.jpg"],
      //   link: "#",
      // },
      // {
      //   title: "Portfolio Site",
      //   images: ["/images/web2.jpg"],
      //   link: "#",
      // },
      // {
      //   title: "Admin Dashboard",
      //   images: ["/images/web3.jpg"],
      //   link: "#",
      // },
    ],

    UIUX: [
      {
        title: "Cafery",
        images: ["/images/figma/cafery/1.png", 
          "/images/figma/cafery/2.png", 
          "/images/figma/cafery/3.png", 
        ],
        link: "#",
      },
      {
        title: "Caprisun",
        images: ["/images/figma/caprisun/12.jpg",
          "/images/figma/caprisun/13.jpg",
          "/images/figma/caprisun/14.jpg",
          "/images/figma/caprisun/15.jpg",
         ],
        link: "#",
      },
      {
        title: "Embroidery Machinen",
        images: ["/images/figma/Embroidery Machine/2.jpg",
          "/images/figma/Embroidery Machine/3.jpg",
          "/images/figma/Embroidery Machine/4.jpg",
          "/images/figma/Embroidery Machine/7.jpg",
        ],
        link: "#",
      },
      {
        title: "Food App",
        images: ["images/figma/Food App/13.jpg",
          "images/figma/Food App/14.jpg",
          "images/figma/Food App/15.jpg",
          "images/figma/Food App/16.jpg",
        ],
        link: "#",
      },
      {
        title: "Life TimeCreation",
        images: ["/images/figma/Life TimeCreation/2.jpg", 
          "/images/figma/Life TimeCreation/3.jpg",
          "/images/figma/Life TimeCreation/5.jpg",
          "/images/figma/Life TimeCreation/7.jpg",
        ],
        link: "#",
      },

    ],
  };

  const [category, setCategory] = useState("Web");
  const [activeImages, setActiveImages] = useState({});
  const [showAll, setShowAll] = useState(false);

  // ✅ Handle URL hash
  useEffect(() => {
    if (location.hash) {
      const hash = location.hash.replace("#", "");

      if (hash === "mobile") setCategory("Mobile");
      if (hash === "web") setCategory("Web");
      if (hash === "uiux") setCategory("UIUX");
    }
  }, [location]);

  // ✅ Reset "View More" when category changes
  useEffect(() => {
    setShowAll(false);
  }, [category]);

  const handleImageChange = (index, img) => {
    setActiveImages({
      ...activeImages,
      [index]: img,
    });
  };

  // ✅ Limit cards
  const visibleData = showAll
    ? data[category]
    : data[category].slice(0, 4);

  return (
    <section className="portfolio">

      {/* HEADER */}
      <div className="portfolio-hero">
        <h1>Our Portfolio</h1>
        <p>Explore our work</p>

        {/* TABS */}
        <div className="category-tabs">
         
          <button
            className={category === "Web" ? "active" : ""}
            onClick={() => setCategory("Web")}
          >
            Web Development
          </button>

          <button
            className={category === "UIUX" ? "active" : ""}
            onClick={() => setCategory("UIUX")}
          >
            UI/UX Design
          </button>

           <button
            className={category === "Mobile" ? "active" : ""}
            onClick={() => setCategory("Mobile")}
          >
            Mobile
          </button>

        </div>
      </div>

      {/* GRID */}
      <div className="portfolio-grid">
        {visibleData.map((item, index) => {

          const currentImage =
            activeImages[index] || item.images[0];

          return (
            <div key={index} className="portfolio-card">
<img
  src={currentImage}
  alt={item.title}
  className={`card-img ${category === "Mobile" ? "mobile-img" : ""}`}
/>
              {/* MAIN IMAGE */}
           

              {/* THUMBNAILS */}
              <div className="thumbs">
                {item.images.map((img, i) => (
                  <img
                    key={i}
                    src={img}
                    alt="thumb"
                    className={
                      currentImage === img ? "active" : ""
                    }
                    onClick={() =>
                      handleImageChange(index, img)
                    }
                  />
                ))}
              </div>
<div className="card-footer">
  <h3 className="card-title">{item.title}</h3>
{category !== "UIUX" && (
  <a
    href={item.link}
    target="_blank"
    rel="noopener noreferrer"
    className="card-btn"
  >
    {category === "Mobile" && "Install →"}
    {category === "Web" && "Visit →"}
  </a>
)}
</div>

            </div>
          );
        })}
      </div>

      {/* VIEW MORE BUTTON */}
      {data[category].length > 4 && (
        <div style={{ textAlign: "center", marginTop: "20px" }}>
          <button
            className="explore-btn"
            onClick={() => setShowAll(!showAll)}
          >
            {showAll ? "Show Less ↑" : "View More ↓"}
          </button>
        </div>
      )}

    </section>
  );
};

export default Portfolio;